"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _AccordionDetails = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var css = _interopRequireWildcard(require("./Accordion.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Accordion = function Accordion(_ref) {
  var content = _ref.content;
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: content.map(function (el, i) {
      return (0, _jsxRuntime.jsxs)(_Accordion["default"], {
        css: css.accordionItem,
        defaultExpanded: el.defaultExpanded // Will be fine as long as we don't create accordion items dynamically...
        // eslint-disable-next-line react/no-array-index-key
        ,
        children: [(0, _jsxRuntime.jsx)(_AccordionSummary["default"], {
          expandIcon: (0, _jsxRuntime.jsx)(_ExpandMore["default"], {
            css: css.icon
          }),
          "aria-controls": "panel".concat(i, "-content"),
          id: "panel".concat(i, "-header"),
          children: (0, _jsxRuntime.jsx)("h3", {
            className: "heading1",
            css: css.summary,
            children: el.summary
          })
        }), (0, _jsxRuntime.jsx)(_AccordionDetails["default"], {
          children: el.details
        })]
      }, i);
    })
  });
};

Accordion.propTypes = {
  content: (0, _propTypes.arrayOf)((0, _propTypes.exact)({
    summary: _propTypes.string.isRequired,
    details: _propTypes.node.isRequired,
    defaultExpanded: _propTypes.bool
  }).isRequired).isRequired
};
var _default = Accordion;
exports["default"] = _default;